var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"15","height":"20","viewBox":"0 0 15 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('g',{attrs:{"stroke":"var(--color-neutral-10)","stroke-width":"1.667"}},[_c('path',{attrs:{"d":"M7 5h6M5 15h6M8 15l2-10"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }